import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToCelsiusPipe } from './to-celsius.pipe';
import { ToFahrenheitPipe } from './to-fahrenheit.pipe';



@NgModule({
  declarations: [
    ToCelsiusPipe,
    ToFahrenheitPipe,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ToCelsiusPipe,
    ToFahrenheitPipe,
  ]
})
export class TemperaturePipesModule { }
